<div class="w-full flex flex-col items-center justify-center sm:pt-10 md:pt-7 my-auto" [class]="noInternetHeight">
    <div class="overflow-hidden w-4/5 md:w-2/3 lg:w-2/5">
        <img *ngIf="imgName" class="w-full h-full object-center" [src]="'assets/image/' + imgName + '.webp'" alt="">
    </div>
    <p *ngIf="errorStatus!=404" class="text-center font-extrabold text-2xl sm:text-3xl md:text-3xl my-12 text-lightMode-600 dark:text-darkMode-400 select-none">
        {{errorContent}}
    </p>
</div>